"use client";

import { apiFetch } from "@/lib/ftv-api/api-ftv";
import { setCheckoutData, setCouponAmount, setCouponCode } from "@/redux/checkout/checkoutpage";
import Image from "next/image";
import { useParams } from "next/navigation";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllCountryImage } from "../imageComponent/allCountry";
import parse from "html-react-parser";
import { Label } from "../ui/label";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { ApiError } from "@/lib/ftv-api/api-error";
const OrderSummary = () => {
  const params = useParams();
  const {
    locale,
    checkout_in
  } = params;
  const pageUrl = checkout_in;
  const hasFetched = useRef(false);
  const dispatch = useDispatch();
  const [errorMsg, setErrorMsg] = useState("");
  const [isErrorMsg, setIsErrorMsg] = useState("");
  const [isSuccessMsg, setIsSuccessMsg] = useState("");
  const travelCount = useSelector(s => s.travel.travelCount);
  const checkoutPage = useSelector(s_0 => s_0.checkoutPage.checkoutData);
  const [discountAmount, setdiscountAmount] = useState(0);
  const [couponInputValue, setCouponInputValue] = useState("");
  const couponCode = useSelector(state => state.checkoutPage.couponCode);
  const couponAmount = useSelector(state_0 => state_0.checkoutPage.couponAmount);
  const embassyFees = checkoutPage?.[0].embassey_fee * travelCount;
  const processingFees = (checkoutPage?.[0].price - checkoutPage?.[0].embassey_fee) * travelCount;
  const totalFees = embassyFees + processingFees;
  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    const checkoutData = async () => {
      try {
        const res = await apiFetch(`/api/${locale}/checkout/${pageUrl}`, {
          cache: "no-store"
        });
        if (!res) return;
        dispatch(setCheckoutData(res));
      } catch (error) {
        if (error instanceof ApiError) {
          setErrorMsg(error.message);
          console.error(error.status, error.message);
        }
      }
    };
    checkoutData();
  }, [locale, pageUrl, dispatch]);
  const changeHandlerCoupon = e => {
    setCouponInputValue(e.target.value);
  };
  const applyCouponCode = async () => {
    if (!couponInputValue?.trim()) {
      setIsErrorMsg("Please enter coupon code");
      setTimeout(() => setIsErrorMsg(""), 8000);
      return;
    }
    try {
      const currency_icon = checkoutPage?.[0]?.currency_icon;
      const formdata = new FormData();
      formdata.append("countryCode", currency_icon);
      formdata.append("couponCode", couponInputValue.trim());
      const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow"
      };
      const res_0 = await apiFetch("/api/cupon", requestOptions);
      if (res_0?.status === "success") {
        const discountAmount_0 = res_0.data;
        setIsErrorMsg("");
        setIsSuccessMsg(`Coupon Applied. You just saved ${currency_icon} ${discountAmount_0}`);
        setdiscountAmount(discountAmount_0);
        fetchCheckoutData(true);
        dispatch(setCouponAmount(discountAmount_0));
        dispatch(setCouponCode(couponInputValue.trim()));
        setCouponInputValue("");
      } else {
        throw new Error("Invalid Coupon Code");
      }
    } catch (error_0) {
      setIsSuccessMsg("");
      setdiscountAmount(0);
      fetchCheckoutData(false);
      dispatch(setCouponAmount(0));
      dispatch(setCouponCode(""));
      if (error_0 instanceof ApiError) {
        setIsErrorMsg(error_0.message);
      } else {
        setIsErrorMsg("Invalid Coupon Code");
      }
    }
  };
  const fetchCheckoutData = async isActive => {
    const url = isActive ? `/api/${locale}/checkout/${pageUrl}/FTVNY` : `/api/${locale}/checkout/${pageUrl}`;
    try {
      const res_1 = await apiFetch(url, {
        cache: "no-store"
      });
      if (!res_1) return;
      // console.log(res)
      dispatch(setCheckoutData(res_1));
    } catch (error_1) {
      if (error_1 instanceof ApiError) {
        setErrorMsg(error_1.message);
        console.error(error_1.status, error_1.message);
      }
    }
  };
  return <>
      {errorMsg && <p className="text-xs text-rose-700 font-normal">{errorMsg}</p>}
      <h2 className="font-semibold text-primary/85 font-poppins text-lg tracking-wide">
        Order Summary
        <span className="pl-4">
          {travelCount >= 1 ? "" + travelCount : " "} pax
        </span>
      </h2>
      <figure className="mt-6 mb-3">
        <Image src={getAllCountryImage(checkoutPage?.[0].title)} width={450} height={300} alt={checkoutPage?.[0]?.urllink || "checkoutPage_img"} className="w-full h-auto rounded" />
      </figure>
      <h3 className="pl-1 mb-4 font-poppins text-lg font-semibold text-primary/80 tracking-wide">
        {checkoutPage?.[0].title}
      </h3>
      <div className="border py-3 px-4 font-poppins border-border rounded text-xs text-primary/50">
        {checkoutPage?.[0].duration} Single Entry Visa
      </div>
      <div className="flex justify-between font-poppins text-primary/70 text-sm font-semibold mt-5">
        <span>Embassy Fees</span>{" "}
        <span className="font-bold">
          {checkoutPage?.[0].currency_icon}{" "}
          {checkoutPage?.[0].embassey_fee * travelCount}
        </span>
      </div>
      <div className="flex justify-between font-poppins text-primary/70 text-sm font-semibold mt-5">
        <span>Processing Fees</span>{" "}
        <span className="font-bold">
          {checkoutPage?.[0].currency_icon}{" "}
          {(checkoutPage?.[0].price - checkoutPage?.[0].embassey_fee) * travelCount}
        </span>
      </div>
      {discountAmount > 0 && <div className="flex justify-between text-primary/70 text-sm font-semibold mt-5">
          <span>Discount </span>
          <span className="font-bold">
            - {checkoutPage?.[0].currency_icon} {discountAmount}
          </span>
        </div>}
      {discountAmount > 0 ? <div className="flex justify-between font-poppins text-primary/70 text-sm font-semibold mt-5">
          <span className="font-poppins font-semibold text-lg">Total Fees</span>
          <span className="font-poppins font-semibold text-lg">
            {checkoutPage?.[0].currency_icon}
            {Math.round(totalFees - discountAmount)}
          </span>
        </div> : <div className="flex justify-between text-primary/70 text-sm font-semibold mt-5">
          <span className="font-poppins font-semibold text-lg">Total Fees</span>
          <span className="font-poppins font-semibold text-lg">
            {checkoutPage?.[0].currency_icon} {totalFees}
          </span>
        </div>}

      <div>
        <div className="ftv-field mt-10 relative shadow-none border border-gray-200">
          <Label htmlFor="coupon" className="pl-1 text-xs font-normal font-poppins">
            Promo Code
          </Label>
          <Input type="text" className="border-primary/20 mt-2 focus-visible:outline-none focus-visible:ring-0" placeholder="Enter Here" value={couponInputValue || ""} onChange={changeHandlerCoupon} name="coupon" id="coupon" />
          <Button variant="destructive" className="absolute right-2.5 top-8.5 font-poppins" onClick={applyCouponCode}>
            Apply
          </Button>
        </div>
        {isErrorMsg && <p className="text-xs font-medium text-red-600 pl-1">{isErrorMsg}</p>}
        {isSuccessMsg && <p className="text-xs font-medium text-green-600 pl-2">
            {isSuccessMsg}
          </p>}
        <p className=" mt-5 font-semibold text-[15px] text-primary/80 font-poppins tracking-wide">
          Processing details
        </p>
        <div className="flex justify-between text-primary/75 text-[13px] font-normal font-poppins mt-3">
          <span>Citizenship</span> <span>{checkoutPage?.[0].country_site}</span>
        </div>
        <div className="flex justify-between text-primary/75 text-[13px] font-normal font-poppins mt-3">
          <span>Destination</span> <span>{checkoutPage?.[0].country}</span>
        </div>
        <div className="flex justify-between text-primary/75 text-[13px] font-normal font-poppins mt-3">
          <span>Visa Type</span> <span>{checkoutPage?.[0].type}</span>
        </div>
        <div className="flex justify-between text-primary/75 text-[13px] font-normal font-poppins mt-3">
          <span>As fast as</span> <span>{checkoutPage?.[0].tat}</span>
        </div>
        <div className="flex justify-between text-primary/75 text-[13px] font-normal font-poppins mt-3 mb-5">
          <span>Duration of stay</span>{" "}
          <span>up to {checkoutPage?.[0].duration}</span>
        </div>
        <Accordion type="single" collapsible defaultValue="item-1">
          <AccordionItem value="item-1">
            <AccordionTrigger className="text-sm text-primary/80 font-medium font-poppins">
              Specific Rule
            </AccordionTrigger>
            <AccordionContent className="text-xs leading-6 font-normal text-primary/70 font-poppins">
              {typeof checkoutPage?.[0]?.specificrule === "string" ? parse(checkoutPage[0].specificrule) : null}
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-2">
            <AccordionTrigger className="text-sm text-primary/80 font-medium font-poppins">
              General Information
            </AccordionTrigger>
            <AccordionContent className="text-xs leading-6 font-normal text-primary/70 font-poppins">
              {typeof checkoutPage?.[0]?.grule === "string" ? parse(checkoutPage[0].grule) : null}
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </>;
};
export default OrderSummary;